<draggable-container [prefix]="data.prefix">

  <!-- Starting container -->
  <div #wrapper>
    <div class="w-100 border">
      <!-- <button class="btn btn-toolbar" (click)="addElement($event)"><i class="fa-solid fa-plus"></i></button> -->
      <button class="btn btn-toolbar btn-list-type" (click)="toggleType()">{{data.ordered?'Numerada':'No numerada'}}</button>
      <label class="px-3 btn-toolbar" for="markers">Marcador:&nbsp;
        <select [(ngModel)]="data.mark" for="markers" name="markers" id="markers">
          <ng-container *ngIf="data.ordered">
            <option *ngFor="let marker of olMarkers" [value]="marker">{{marker}}</option>
          </ng-container>
          <ng-container *ngIf="!data.ordered">
            <option *ngFor="let marker of ulMarkers" [value]="marker">{{marker}}</option>
          </ng-container>
        </select>
      </label>
      <span>
        <button [disabled]="data.indent <= 0" class="btn btn-toolbar" (click)="data.indent=data.indent-1"><i
          class="fa-solid fa-outdent"></i></button>
        <button [disabled]="data.indent >= 6" class="btn btn-toolbar" (click)="data.indent=data.indent+1"><i
          class="fa-solid fa-indent"></i></button>
      </span>
      <label *ngIf="data.ordered" class="px-3 btn-toolbar" for="values">Inicio:&nbsp;
        <input type="number" class="input-list-start" [(ngModel)]="data.startList">
      </label>
    </div>
    <ng-container *ngTemplateOutlet="data.ordered ? ordered : unordered;">
    </ng-container>
  </div>

  <!-- Ordered list -->
  <ng-template #ordered>
    <ol [type]="data.mark" [start]="data.startList" [style]="{'padding-left':'calc(2rem + '+15*data.indent+'px)'}">
      <ng-container *ngTemplateOutlet="listIterator">
      </ng-container>
    </ol>
  </ng-template>

  <!-- Unordered list -->
  <ng-template #unordered>
    <ul [type]="data.mark" [style]="{'padding-left':'calc(2rem + '+15*data.indent+'px)'}">
      <ng-container *ngTemplateOutlet="listIterator">
      </ng-container>
    </ul>
  </ng-template>

  <!-- Iterator through list elements -->
  <ng-template #listIterator>
    <ng-container *ngFor="let item of data.list; let i=index; trackBy: trackByFn">
      <li>
        <!-- TODO: de normal, está renderizado. Si se clica, comienza la edición y se abre un quill editor -->
        <textarea [id]="'li-text-'+data.prefix+'-'+i" cdkTextareaAutosize class="w-100 transparent" [value]="item" [(ngModel)]="data.list[i]"
          (keydown.enter)="addElement($event, i+1)" (keydown.backspace)="checkRemoveLine($event, i)">
        </textarea>
      </li>
    </ng-container>
  </ng-template>

</draggable-container>



<!-- LIST ELEMENT RENDERING
  1. Base element in a ng-container. Redirects to listTemplate
  2. listTemplate checks if the list is ordered or unordered. Redirect to the
     corresponding template
  3. The template wraps the list content in a ol or ul HTML element and sends
     the data to listIterator template
  4. listIterator executes a ngFor loop through the elements of the list, and
     checks if they are an item (leaf) or another list (branch)
  5. If it's an item, renders the item template
  6. If it's another list, repeats from steps 2 with this list data
-->

<!-- <draggable-container [prefix]="data.prefix"> -->

<!-- Starting container -->
<!-- <div #wrapper>
    <ng-container
        *ngTemplateOutlet="listTemplate; context:{list:data, i:'', depth: 0}">
    </ng-container>
  </div> -->

<!-- The value is an item -->
<!-- <ng-template #itemTemplate let-item="item" let-i="i" let-depth="depth">
    <li (click)="changeListType($event, i)">
      <textarea cdkTextareaAutosize class="w-100 transparent" [value]="item"
      (keyup)="checkKey($event, i)">
      </textarea>
    </li>
  </ng-template> -->


<!-- The value is a list -->
<!-- <ng-template #listTemplate let-list="list" let-i="i" let-depth="depth">
    <ng-container
        *ngTemplateOutlet="list.ordered ? ordered : unordered;
                           context:{list:list.list, i, depth}">
    </ng-container>
  </ng-template> -->

<!-- Ordered list -->
<!-- <ng-template #ordered let-list="list" let-i="i" let-depth="depth">
    <ol>
      <ng-container
        *ngTemplateOutlet="listIterator;
                           context:{list:list, i, depth}">
    </ng-container>
    </ol>
  </ng-template> -->

<!-- Unordered list -->
<!-- <ng-template #unordered let-list="list" let-i="i" let-depth="depth">
    <ul>
      <ng-container
        *ngTemplateOutlet="listIterator;
                           context:{list:list, i, depth}">
      </ng-container>
    </ul>
  </ng-template> -->

<!-- Iterator through list elements -->
<!-- <ng-template #listIterator let-list="list" let-i="i" let-depth="depth">
    <ng-container *ngFor="let item of list; let currentIndex=index; trackBy: trackByFn">
      <ng-container
          *ngTemplateOutlet="isList(item) ? listTemplate : itemTemplate;
                             context:isList(item) ?
                             {list: item, i: i+currentIndex, depth: depth+1}:{item, i: i+currentIndex, depth}"></ng-container>
    </ng-container>
  </ng-template>
</draggable-container> -->
